import { validateAndUseSchema } from "../utils/schema/schemaValidator";
import { shoppingListItemSchema } from "./shoppingListItemSchema"
/**
 * Schema for a frequent shopping list
 */
export const frequentListSchema = {
  id: {
    type: "string",
    required: true,
    validate: (value) => {
      return /^\d+$/.test(value) ? null : "ID must contain only numeric characters";
    },
  },

  name: {
    type: "string",
    required: true,
    minLength: 1,
    maxLength: 100,
  },

  interval: {
    type: "number",
    required: true,
    min: 1,
  },

  lastUsed: {
    type: "number", // Timestamp
    required: false, // Can be null initially
  },

  nextSuggestion: {
    type: "number", // Timestamp
    required: false, // Can be null initially
  },

  shoppingListItems: {
    type: "array",
    required: true,
    default: [], // Default to empty array
    itemSchema: shoppingListItemSchema,
  },
};

export default validateAndUseSchema(frequentListSchema, "frequentList");
